module.exports = __webpack_public_path__ + "img/shoot_00006.1721fab7.png";